/**
 * Shared HomeV3 design tokens.
 * Consumed by HomeV3Page + LibraryPage (+ future pages) so every rebuilt
 * page uses byte-identical colours and font stacks.
 */
export const T = {
  DARK_BROWN:    "#2C1810",
  GOLD:          "#C9A84C",
  PARCHMENT_LT:  "#F0E6CC",
  PARCHMENT_MD:  "#E8D2A0",
  PARCHMENT_HI:  "#EDD9A3",
  PARCHMENT_LO:  "#DFC99A",
  BODY_TEXT:     "#3D2314",
  MUTED_BROWN:   "#8B6347",
  SANSKRIT_TEXT: "#5C3D2E",

  F_DISPLAY: "'Cinzel Decorative', serif",
  F_HEADING: "'Cinzel', serif",
  F_BODY:    "'EB Garamond', serif",
  F_DEVNAG:  "'Noto Serif Devanagari', serif",
};

// Route mapping shared with HomeV3.
export const R = {
  home:        "/",
  library:     "/library",
  collections: "/collections",
  mycraftz:    "/mycraftz",
  sanctuary:   "/my-sanctuary",
  bodha:       "/bodha",
  sankalpa:    "/sankalpa",
  sadhana:     "/sadhana",
  siddhi:      "/siddhi",
  profile:     "/login",
};

// Local emblem asset (transparent PNG) shared between pages.
export const EMBLEM = "/homepage-assets/asset-logo-emblem.png";
